import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import MainLayout from '../layouts/MainLayout.vue'
import login from '../views/auth/login.vue'
import Empresa from '../components/VerEmpresa.vue'
import Catalogo from '../components/VerCatalogo.vue'
import Inventario from '../components/VerInventario.vue'
import MovimientoStock from '../components/EntSalForm.vue'
import Movimientos from '../components/VerMovimientos.vue'
import Almacenes from '../components/VerAlmacenes.vue'
import Proveedores from '../components/VerProveedores.vue'
import Categorias from '../components/VerCategorias.vue'
import Ventas from '../components/VerVentas.vue'
import NuevaVenta from '../components/NuevaVenta.vue'
import Clientes from '../components/VerClientes.vue'
import Pagos from '../components/VerPagos.vue'
import Creditos from '../components/VerCreditos.vue'
import LogisticaVentas from '../components/VerLogisticaVentas.vue'
import VentaDetalle from '../components/VerVenta.vue'
import MovimientoDetalle from '../components/MovimientoDetalle.vue'
import StockDetallado from '../components/StockDetallado.vue'
import Promociones from '../components/VerPromociones.vue'
import VerDetallePromocion from '../components/VerDetallePromocion.vue'
import NuevaPromocion from '../components/NuevaPromocion.vue'
import Reportes from '../components/Reportes.vue'
import prueba from '../components/prueba.vue'
import cierres from '../components/Cierres.vue'
import Auditoria from '../components/Auditoria.vue'
import AdminPanel from '../components/AdminPanel.vue'
import MiPerfil from '../components/MiPerfil.vue'
import Respaldo from '../components/Respaldo.vue'
import Tickets from '../components/Tickets.vue'
import HistorialDetallado from '../components/HistorialDetallado.vue'


const routes = [
  {
    path: '/',
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'home',
        component: HomeView
      },
      {
        path: 'empresa',
        name: 'empresa',
        component: Empresa,
        meta: { permission: 'ver-empresas' }
      },
      {
        path: 'catalogo',
        name: 'catalogo',
        component: Catalogo,
        meta: { permission: 'ver-productos' }
      },
      {
        path: 'inventario',
        name: 'inventario',
        component: Inventario,
        meta: { permission: 'ver-inventarios' }
      },
      {
        path: 'movform',
        name: 'movform',
        component: MovimientoStock,
        meta: { permission: 'crear-movimientos' }
      },
      {
        path: 'movimientos',
        name: 'movimientos',
        component: Movimientos,
        meta: { permission: 'ver-movimientos' }
      },
      {
        path: 'almacenes',
        name: 'almacenes',
        component: Almacenes,
        meta: { permission: 'ver-almacenes' }
      },
      {
        path: 'proveedores',
        name: 'proveedores',
        component: Proveedores,
        meta: { permission: 'ver-proveedores' }
      },
      {
        path: 'categorias',
        name: 'categorias',
        component: Categorias,
        meta: { permission: 'ver-categorias' }
      },
      {
        path: 'ventas',
        name: 'ventas',
        component: Ventas,
        meta: { permission: 'ver-ventas' }
      },
      {
        path: 'nuevaventa',
        name: 'nuevaventa',
        component: NuevaVenta,
        meta: { permission: 'crear-ventas' }
      },
      {
        path: 'ventas/editar/:id',
        name: 'EditarVenta',
        component: NuevaVenta,
        props: route => ({ id: route.params.id, modo: 'editar' }),
        meta: { permission: 'crear-ventas' }
      },
      {
        path: 'despacho/confirmar/:id',
        name: 'ConfirmarDespacho',
        component: NuevaVenta,
        props: route => ({ id: route.params.id, modo: 'despacho' }),
        meta: { permission: 'ver-logistica' }
      },
      {
        path: 'clientes',
        name: 'clientes',
        component: Clientes,
        meta: { permission: 'ver-clientes' }
      },
      {
        path: 'verpagos',
        name: 'verpagos',
        component: Pagos,
        meta: { permission: 'ver-pagos' }
      },
      {
        path: 'creditos',
        name: 'creditos',
        component: Creditos,
        meta: { permission: 'ver-creditos' }
      },
      {
        path: 'historial/:id',
        name: 'historial',
        component: HistorialDetallado,
        props: true,
        meta: {
          permissions: ['ver-creditos', 'ver-clientes']
        }
      },
      {
        path: 'ventalog',
        name: 'ventalog',
        component: LogisticaVentas,
        meta: { permission: 'ver-logistica' }
      },
      {
        path: '/ventas/:id',
        name: 'VentaDetalle',
        component: VentaDetalle,
        meta: { permission: 'ver-ventas' }
      },
      {
        path: '/movimientos/:tipo/:numcontrol',
        name: 'MovimientoDetalle',
        component: MovimientoDetalle,
        props: true,
        meta: { permission: 'ver-movimientos' }
      },
      {
        path: '/inventario/producto/:productoId',
        name: 'StockDetallado',
        component: StockDetallado,
        props: true,
        meta: { permission: 'ver-inventarios' }

      },
      {
        path: '/promociones',
        name: 'Promociones',
        component: Promociones,
        meta: { permission: 'ver-promociones' }
      },
      {
        path: '/promocion/:id',
        name: 'VerDetallePromocion',
        component: VerDetallePromocion,
        props: true,
        meta: { permission: 'ver-promociones' }
      },
      {
        path: '/promociones/editar/:id',
        name: 'EditarPromocion',
        component: NuevaPromocion,
        props: true,
        meta: { permission: 'crear-promociones' }
      },
      {
        path: '/nuevapromocion',
        name: 'NuevaPromocion',
        component: NuevaPromocion,
        meta: { permission: 'crear-promociones' }
      },
      {
        path: '/prueba',
        name: 'Prueba',
        component: prueba
      },
      {
        path: '/reportes',
        name: 'Reportes',
        component: Reportes,
        meta: { permission: 'gestionar-reportes' }
      },
      {
        path: '/cierres',
        name: 'Cierres',
        component: cierres,
        meta: { permission: 'gestionar-cierres' }
      },
      {
        path: '/auditoria',
        name: 'Auditoria',
        component: Auditoria,
        meta: { permission: 'gestionar-auditorias' }
      },
      {
        path: '/respaldos',
        name: 'Respaldo',
        component: Respaldo,
        meta: { permission: 'gestionar-respaldos' }
      },
      {
        path: '/admin',
        name: 'AdminPanel',
        component: AdminPanel,
        meta: { permission: 'gestionar-usuarios' }
      },
      {
        path: '/perfil',
        name: 'MiPerfil',
        component: MiPerfil
      },
      {
        path: '/tickets',
        name: 'Tickets',
        component: Tickets,
      }

    ]
  },
  {
    path: '/login',
    name: 'login',
    component: login,
    meta: { requiresAuth: false }
  }

]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const token = sessionStorage.getItem('token')
  const perms = JSON.parse(sessionStorage.getItem('permissions') || '[]')

  if (to.meta.requiresAuth && !token) {
    return next('/login')
  }

  if (( to.name === 'login') && token) {
    return next('/')
  }

  if (to.meta.permission) {
    if (!perms.includes(to.meta.permission)) {
      return next('/')
    }
  }

  next()
})

export default router
